const data = [
	{
		OtherCertifications: `Other Important Courses Certifications`,
	},
	{
		OtherCertifications: `Six Months online course on “ WC 101X: Workplace Communication” an online 
		learning initiative by IIT Bombay`,
	},
	{
		OtherCertifications: `Six Months online course on “ WC 101X: Workplace Communication” an online 
		learning initiative by IIT Bombay`,
	},
];

export default data;
